import {ALL_SUBQUERIES, getItem, setItem} from '../helpers/config'
import country from './country'
import subquery from '../dashboardItems/subquery.json'

const getSubqueries = () => (
    getItem(ALL_SUBQUERIES)
)

const setSubqueries = (sq) => {
    setItem(sq || subquery, ALL_SUBQUERIES)
}

const getSubqueryForItem = (id) => {
    let subqueries = getSubqueries()
    if (!subqueries) {
        setSubqueries()
        subqueries = getSubqueries()
    }

    // return subqueries[id]
    return subqueries.subqueryItems.find((subqueryItem) => { return subqueryItem.id == id })
}

const updateSubqueryFilter = (id, countryValue, tableName) => {
    let subquery = getSubqueryForItem(id)

    if (subquery !== undefined) {
        let vizState = JSON.parse(subquery?.vizState)
        let oldFilters = vizState.query.filters

        vizState.query.filters = country
            .mapCountryValueToFilter(
                countryValue,
                tableName,
                oldFilters
            )
        subquery.vizState = JSON.stringify(vizState)

        let subqueries = getSubqueries()
        console.log("subquery before: ", subqueries)
        subqueries.subqueryItems = subqueries.subqueryItems
            .filter((subqueryItem) => { return subqueryItem.id !== id })
        subqueries.subqueryItems.push(subquery)
        console.log("subquery after: ", subqueries)
        setSubqueries(subqueries)
    }

}

export default {
    getSubqueries,
    setSubqueries,
    getSubqueryForItem,
    updateSubqueryFilter,
}